import { defineStore } from 'pinia'
import { ref, readonly } from 'vue'
import { useFlash } from 'src/biz_spa/composables'
import { castAttributesForCamelCase } from 'src/biz_spa/modules/string_converter'
import axios from 'axios'

export type RpaErrorLog = {
  storeName: string
  kind: string
  errorMessage: string
}

export const useRpaErrorLogsStore = defineStore('rpaErrorLogs', () => {
  const { updateFlash } = useFlash()
  const rpaErrorLogs = ref<RpaErrorLog[]>([])
  const rpaErrorLogsLoading = ref<boolean>(false)

  const readRpaErrorLogs = async (companyUuid: string) => {
    rpaErrorLogsLoading.value = true
    return axios
      .get(`/api/companies/${ companyUuid }/rpa_error_logs`)
      .then(res => {
        rpaErrorLogs.value = res.data.data.map((v: RpaErrorLog) => castAttributesForCamelCase(v))
      })
      .catch(err => {
        updateFlash({ type: 'alert', message: err.response.data.errors[0].detail })
      })
      .finally(() => {
        rpaErrorLogsLoading.value = false
      })
  }

  return {
    rpaErrorLogsLoading: readonly(rpaErrorLogsLoading),
    rpaErrorLogs: readonly(rpaErrorLogs),
    readRpaErrorLogs,
  }
})
